import React from 'react';
import { InfoTooltip } from 'framework-ui-components';

const InfoAzioneDisabilitata = () => (
  <InfoTooltip left>
    Seleziona le dichiarazioni per utilizzare questa funzione
  </InfoTooltip>
);

export default InfoAzioneDisabilitata;
